import ReactDOM from 'react-dom';
import { useMountedElement } from '@hooks/useMountedElement';

export const ModalPortal = ({ children }) => {
  const modalsNode = useMountedElement('#modals');
  return modalsNode && ReactDOM.createPortal(children, modalsNode);
};
